import {
    FETCH_DRIVE_FILES_REQUEST,
    FETCH_DRIVE_FILES_SUCCESS,
    FETCH_DRIVE_FILES_FAILURE,
    SYNC_DRIVE_FILES_REQUEST,
    SYNC_DRIVE_FILES_SUCCESS,
    SYNC_DRIVE_FILES_FAILURE,
    CREATE_DRIVE_FOLDER_REQUEST,
    CREATE_DRIVE_FOLDER_SUCCESS,
    CREATE_DRIVE_FOLDER_FAILURE
} from '../constants/driveFiles.constant';

const initialState = {
    // Structure: { [folderId]: { driveFiles, gdriveFolderId, lastSyncedAt, loading, syncing, creating, error } }
    byFolderId: {}
};

const driveFilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DRIVE_FILES_REQUEST:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        loading: true,
                        error: null,
                        // record latest request id for this folder
                        latestRequestId: action.payload.requestId
                    }
                }
            };

        case FETCH_DRIVE_FILES_SUCCESS: {
            const { folderId, data, requestId } = action.payload;
            const existing = state.byFolderId[folderId] || {};
            // If there's a recorded latestRequestId and it doesn't match this response, ignore it
            if (existing.latestRequestId && requestId && existing.latestRequestId !== requestId) {
                return state;
            }
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [folderId]: {
                        ...existing,
                        driveFiles: data.driveFiles,
                        gdriveFolderId: data.gdriveFolderId,
                        lastSyncedAt: data.lastSyncedAt,
                        loading: false,
                        error: null,
                        latestRequestId: requestId
                    }
                }
            };
        }

        case FETCH_DRIVE_FILES_FAILURE: {
            const { folderId, error, requestId } = action.payload;
            const existing = state.byFolderId[folderId] || {};
            if (existing.latestRequestId && requestId && existing.latestRequestId !== requestId) {
                return state;
            }
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [folderId]: {
                        ...existing,
                        loading: false,
                        error: error,
                        latestRequestId: requestId
                    }
                }
            };
        }

        case SYNC_DRIVE_FILES_REQUEST:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        syncing: true
                    }
                }
            };

        case SYNC_DRIVE_FILES_SUCCESS:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        driveFiles: action.payload.data.driveFiles,
                        lastSyncedAt: action.payload.data.lastSyncedAt,
                        syncing: false
                    }
                }
            };

        case SYNC_DRIVE_FILES_FAILURE:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        syncing: false
                    }
                }
            };

        case CREATE_DRIVE_FOLDER_REQUEST:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload]: {
                        ...state.byFolderId[action.payload],
                        creating: true
                    }
                }
            };

        case CREATE_DRIVE_FOLDER_SUCCESS:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        gdriveFolderId: action.payload.gdriveFolderId,
                        creating: false
                    }
                }
            };

        case CREATE_DRIVE_FOLDER_FAILURE:
            return {
                ...state,
                byFolderId: {
                    ...state.byFolderId,
                    [action.payload.folderId]: {
                        ...state.byFolderId[action.payload.folderId],
                        creating: false
                    }
                }
            };

        default:
            return state;
    }
};

export default driveFilesReducer;

